export const GET_BRAND_INFO = 'GET_BRAND_INFO';
export const SELECT_TENANT = 'SELECT_TENANT';
export const SHARE_DATA_WITH_BRAND = 'SHARE_DATA_WITH_BRAND';
export const SET_IS_LOADING = 'SET_IS_LOADING';
